import React, { useEffect, useState } from "react";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import MaterialPagination from "../../../styles/materialPagination";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { useHistory } from "react-router-dom";
import Notification from "../../../elements/notification/Notification";
import RateList from "./RateList";
import RateFilter from "./RateFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";

const RatesContainer = ({ match }) => {
  const [rates, setRates] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "rates", false, true),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "connection.service.name": checkFilterItem(history, "connection.service.name", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchRates = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/rates" + filterUrl + "&connection.project.user.id=" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setRates(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  // TODO Add pusher

  useEffect(() => {
    fetchRates();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="content-head">
        <RateFilter
          filterData={filterData}
          setFilterData={setFilterData}
          userId={match.params.id}
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <RateList rates={rates} />
      {totalPageCount > 1  &&
      <MaterialPagination
        count={totalPageCount}
        shape="rounded"
        page={filterData.page}
        onChange={(event, page) => onChangePage(event, page)}
      />}
    </>
  );
};

export default RatesContainer;